import { AbstractControl, ValidationErrors } from '@angular/forms';

export class PhoneValidators {
    //basic checks - ignore other characters
  static usaPhone(control: AbstractControl): ValidationErrors | null {
    const controlVal = control.value;
    
    // Null check
    if (!controlVal) {
      return null;
    }
    
    const trimmedVal = controlVal.trim();
    
    // Phone number validation
    const phonePattern = /^[\+\d\s\-\(\)]+$/;
    const digitsOnly = controlVal.replace(/\D/g, '');
    
    // Must be 10 digits (US number)
    const isValidLength = digitsOnly.length === 10;
    
    if (!phonePattern.test(controlVal) || !isValidLength) {
      return { invalidPhone: true };
    }
    
    return null;
  }
}
